import api from "app/lib/api";
import endpoints from "static/endpoints";

export const validateToken = async (token) => {
  let url = endpoints.auth.verifyToken;

  if (token) {
    url += `?token=${token}`;
    const response = await api.get(url);

    return response;
  }
};

export const changePassword = async (token, newPassword, confirmPassword) => {
  const url = endpoints.auth.resetPassword;

  if (token && newPassword && confirmPassword) {
    const response = await api.put(url, {
      token,
      newPassword,
      confirmPassword,
    });

    return response;
  }
};
